export default __webpack_public_path__ + "static/media/1879.5da0ff07.png";